import React from 'react';

class CheckboxGrid extends React.Component {
  toggle = (key) => {
    const { value, onChange } = this.props;
    const next = { ...(value || {}) };
    next[key] = !next[key];
    onChange(next);
  };

  render() {
    const { options, value, columns, fieldId, error } = this.props;
    const safe = value || {};
    const hasError = !!error;
    const colClass = columns === 1
      ? 'grid grid-cols-1 gap-2'
      : columns === 3
        ? 'grid grid-cols-1 sm:grid-cols-3 gap-2'
        : 'grid grid-cols-1 sm:grid-cols-2 gap-2';

    return (
      <div data-field-id={fieldId || undefined}>
        <div
          className={colClass}
          style={
            hasError
              ? {
                  padding: '6px',
                  margin: '-6px',
                  borderRadius: '14px',
                  boxShadow: '0 0 0 1px #DC2626',
                }
              : undefined
          }
        >
        {options.map((opt) => {
          const checked = !!safe[opt.key];
          return (
            <button
              key={opt.key}
              type="button"
              onClick={() => this.toggle(opt.key)}
              className="flex items-center gap-3 rounded-xl border-2 px-4 py-3 text-left text-sm transition-colors"
              style={{
                borderColor: checked ? '#7C5CFC' : '#D1D5DB',
                backgroundColor: checked ? '#EFEAFE' : '#FFFFFF',
                color: checked ? '#5B3FE0' : '#1F2937',
              }}
            >
              <span
                className="inline-flex items-center justify-center h-5 w-5 rounded border flex-shrink-0"
                style={{
                  borderColor: checked ? '#7C5CFC' : '#9CA3AF',
                  backgroundColor: checked ? '#7C5CFC' : '#FFFFFF',
                }}
              >
                {checked ? (
                  <svg className="h-3 w-3 text-white" viewBox="0 0 20 20" fill="currentColor">
                    <path
                      fillRule="evenodd"
                      d="M16.7 5.3a1 1 0 010 1.4l-7.5 7.5a1 1 0 01-1.4 0L3.3 9.7a1 1 0 011.4-1.4l3.8 3.8 6.8-6.8a1 1 0 011.4 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                ) : null}
              </span>
              <span className="font-medium">{opt.label}</span>
            </button>
          );
        })}
        </div>
        {hasError ? (
          <p className="mt-2 text-xs font-medium text-[#DC2626]">{error}</p>
        ) : null}
      </div>
    );
  }
}

export default CheckboxGrid;
